<template>
	<div id="app">
		<vue-particles
			class="particles"
			color="#543193"
			:particleOpacity="0.4"
			:particlesNumber="80"
			shapeType="circle"
			:particleSize="4"
			linesColor="#543193"
			:linesWidth="1"
			:lineLinked="true"
			:lineOpacity="0.4"
			:linesDistance="150"
			:moveSpeed="3"
			:hoverEffect="false"
			hoverMode="grab"
			:clickEffect="false"
			clickMode="push"
		>
		</vue-particles>
		<Header />
		<router-view class="router_view" />
		<Footer />
	</div>
</template>
<script>
// @ is an alias to /src
import Header from '@/components/common/Header.vue';
import Footer from '@/components/common/Footer.vue';
export default {
	name: 'App',
	components: {
		Header,
		Footer,
	},
	watch: {
    $route: function(to) {
      this.createPageTitle(to);
    },
  },
  methods: {
    createPageTitle : function(to){
      // タイトルを設定
      if(to.meta.title){
        var setTitle = to.meta.title;
        document.title = setTitle;
        document.querySelector("meta[property='og:title']").setAttribute('content', setTitle);
      } else {
        document.title = '株式会社豆蔵: 採用情報サイト';
        document.querySelector("meta[property='og:title']").setAttribute('content', '株式会社豆蔵: 採用情報サイト');
      }
    }
  },
  mounted() {
    var to = this.$route;
    this.createPageTitle(to);
  }
};
</script>

<style lang="scss">
//normalize//
html {
	-webkit-text-size-adjust: 100%;
	-ms-text-size-adjust: 100%;
	background-image: url('./assets/common/back_dot.png');
	background-repeat: repeat;
	background-size: 40px;
	@media print, screen and (max-width: 1160px) {
		background-size: 30px;
	}
}
body {
	margin: 0;
}
.particles {
	position: fixed;
	z-index: -1;
	// height: 100%;
}
article,
aside,
details,
figcaption,
figure,
footer,
header,
main,
menu,
nav,
section,
summary {
	display: block;
}
audio,
canvas,
progress,
video {
	display: inline-block;
	vertical-align: baseline;
}
audio:not([controls]) {
	display: none;
	height: 0;
}
[hidden],
template {
	display: none;
}
abbr[title] {
	border-bottom: 1px dotted;
}
b,
strong {
	font-weight: bold;
}
dfn {
	font-style: italic;
}
h1 {
	font-size: 2em;
	margin: 0.67em 0;
}
mark {
	background: #ff0;
	color: #000;
}
small {
	font-size: 80%;
}
sub,
sup {
	font-size: 75%;
	line-height: 0;
	position: relative;
	vertical-align: baseline;
}
sup {
	top: -0.5em;
}
sub {
	bottom: -0.25em;
}
img {
	border: 0;
	max-width: 100%;
	height: auto;
}
svg:not(:root) {
	overflow: hidden;
}
figure {
	margin: 1em 40px;
}
hr {
	box-sizing: content-box;
	height: 0;
}
pre {
	overflow: auto;
}
code,
kbd,
pre,
samp {
	font-family: monospace, monospace;
	font-size: 1em;
}
button,
input,
optgroup,
select,
textarea {
	color: inherit;
	font: inherit;
	margin: 0;
}
button {
	overflow: visible;
	border-color: inherit;
	&:focus {
		outline: none;
	}
}
button,
select {
	text-transform: none;
}
button,
html input[type='button'],
input[type='reset'],
input[type='submit'] {
	-webkit-appearance: button;
	cursor: pointer;
}
button[disabled],
html input[disabled] {
	cursor: default;
}
button::-moz-focus-inner,
input::-moz-focus-inner {
	border: 0;
	padding: 0;
}
input {
	line-height: normal;
}
input[type='checkbox'],
input[type='radio'] {
	box-sizing: border-box;
	padding: 0;
}
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
	height: auto;
}
input[type='search']::-webkit-search-cancel-button,
input[type='search']::-webkit-search-decoration {
	-webkit-appearance: none;
}
fieldset {
	border: 1px solid #c0c0c0;
	margin: 0 2px;
	padding: 0.35em 0.625em 0.75em;
}
legend {
	border: 0;
	padding: 0;
}
textarea {
	overflow: auto;
}
optgroup {
	font-weight: bold;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
}
td,
th {
	padding: 0;
}
ul {
	list-style: none;
	margin: 0;
	padding: 0;
}
ol {
	margin: 1em;
	padding: 0;
}
p {
	letter-spacing: 0.1em;
	line-height: 2em;
}
a {
	background-color: transparent;
	color: inherit;
	text-decoration: none;
	transition: 0.2s;
}
a:not([href^='tel']):not(.comingsoon):hover {
	@media print, screen and (min-width: 769px) {
		opacity: 0.5;
	}
}
a[href^='tel'] {
	cursor: default;
	text-decoration: none;
}
//normalize//

.over_display {
	@media print, screen and (min-width: 1161px) {
		display: block;
	}
	@media print, screen and (max-width: 1160px) {
		display: none;
	}
	&.--inline {
		@media print, screen and (min-width: 1161px) {
			display: inline;
		}
	}
}
.under_display {
	@media print, screen and (min-width: 1161px) {
		display: none;
	}
	@media print, screen and (max-width: 1160px) {
		display: block;
	}
}

.tablet_over_display {
	@media print, screen and (min-width: 769px) {
		display: block;
	}
	@media print, screen and (max-width: 768px) {
		display: none;
	}
}
.tablet_under_display {
	@media print, screen and (min-width: 769px) {
		display: none;
	}
	@media print, screen and (max-width: 768px) {
		display: block;
	}
}

@import url('https://fonts.googleapis.com/css?family=Noto+Sans+JP:400,500,700');
@import url('https://fonts.googleapis.com/css?family=Noto+Serif+JP:400,500,700&display=swap');
#app {
	font-family: 'Noto Sans JP', sans-serif;
	// font-family: 'Noto Serif JP', serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #543193;
}
// .router_view {
// 	@media print, screen and (max-width: 1160px) {
//   	top: 100px;
// 		position: relative;
//   }
// }
@font-face {
	font-family: 'ots-mincho';
	src: url('./assets/font/ots-mincho.woff') format('woff');
}

.u-notoM {
	font-family: 'Noto Sans JP', sans-serif;
	font-weight: 500;
}

.u-font-ots {
	font-family: 'ots-mincho', serif !important;
	font-weight: normal !important;
}
a.u-external {
	position: relative;
	text-decoration: underline;
	text-underline-offset: 2px;
	&::after {
		content: '';
		display: inline-block;
		vertical-align: baseline;
		background-image: url('./assets/common/icon-external.svg');
		background-size: contain;
		width: 0.9em;
		height: 0.9em;
		background-position: center bottom;
		margin: 0 0.5em;
		background-repeat: no-repeat;
	}
}

a.underline{
	text-decoration: underline;
	text-underline-offset:2px;
}


.u-mt0-sp {
	@media print, screen and (max-width: 1160px) {
		margin-top: 0 !important;
	}
}

.u-mt0 {
	margin-top: 0 !important;
}

.u-MT1em-sp {
	@media print, screen and (max-width: 1160px) {
		margin-top: -1em !important;
	}
}
.u-MT2em-sp {
	@media print, screen and (max-width: 1160px) {
		margin-top: -2em !important;
	}
}
.u-MT3em-sp {
	@media print, screen and (max-width: 1160px) {
		margin-top: -3em !important;
	}
}
.u-MT4em-sp {
	@media print, screen and (max-width: 1160px) {
		margin-top: -4em !important;
	}
}
</style>
